import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHygan = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "svg2",
	width: 166.29333,
	height: 59.720001,
	viewBox: "0 0 166.29333 59.720001",
	xmlns: "http://www.w3.org/2000/svg",
	"xmlns:svg": "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { id: "defs6" }), /* @__PURE__ */ _jsx("g", {
		id: "g8",
		transform: "matrix(1.3333333,0,0,-1.3333333,0,59.72)",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "g10",
			transform: "scale(0.1)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M 23.7539,329.918 24.5781,159.824 1222.65,157.348 1223.48,333.219 619.074,431.477 23.7539,329.918",
					style: {
						fill: "#ffffff",
						fillOpacity: 1,
						fillRule: "nonzero",
						stroke: "none"
					},
					id: "path12"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m 1137.74,188.188 h -34.51 l -106.726,86.91 v -86.91 h -31.801 v 119.121 h 31.801 l 109.436,-88.954 v 88.954 h 31.8 z m -245.267,0 -18.868,27.097 h -66.671 l 12.972,18.57 h 40.758 l -34.23,49.09 -66.028,-94.757 h -33.961 l 83.008,119.121 h 33.961 l 83.02,-119.121 z m -202.688,17.21 c -17.789,-12.382 -43.219,-18.582 -76.281,-18.582 -27.848,0 -51.168,5.801 -69.938,17.391 -18.781,11.59 -28.171,26.238 -28.171,43.969 0,17.722 9.57,32.492 28.71,44.312 19.129,11.809 42.27,17.719 69.399,17.719 27.133,0 49.68,-5 67.652,-15 l -16.98,-15.328 c -7.371,3.969 -14.781,6.726 -22.231,8.258 -7.468,1.539 -16.129,2.301 -26.019,2.301 -19.039,0 -35.031,-3.891 -47.973,-11.672 -12.937,-7.789 -19.406,-18.008 -19.406,-30.68 0,-12.668 6.289,-22.828 18.867,-30.5 12.57,-7.668 27.801,-11.508 45.68,-11.508 17.89,0 32.84,2.449 44.883,7.328 v 32.723 h 31.808 z m -273.84,29.829 v -47.039 h -32.351 v 47.039 l 67.652,72.082 h 34.77 z m -102.429,72.082 h 34.769 l 35.781,-37.661 -16.5,-17.929 z M 266.625,188.188 h -31.809 v 48.738 h -93.531 v -48.738 h -31.801 v 119.121 h 31.801 v -51.641 h 93.531 v 51.641 h 31.809 z m 357,255.558 L 14.1641,338.707 V 148.676 H 1233.06 V 338.707 L 623.625,443.746",
					style: {
						fill: "#db1c30",
						fillOpacity: 1,
						fillRule: "nonzero",
						stroke: "none"
					},
					id: "path14"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m 14.1641,30.2695 h 9.9375 V 100.574 H 14.1641 V 30.2695",
					style: {
						fill: "#ffffff",
						fillOpacity: 1,
						fillRule: "nonzero",
						stroke: "none"
					},
					id: "path16"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m 71.6172,80.8867 c -2.4844,1.25 -5.3477,1.875 -8.5781,1.875 -3.0782,0 -5.9532,-0.5664 -8.625,-1.6914 -2.6797,-1.1211 -5.0235,-2.7148 -7.0469,-4.7734 h -0.5117 l -0.6992,5.6523 H 38.043 V 30.2695 h 9.7461 v 37.7149 c 1.0898,1.457 2.3515,2.6289 3.7773,3.5156 1.4297,0.8906 2.9024,1.5352 4.4063,1.9453 1.5078,0.4102 2.9804,0.625 4.4101,0.625 2.9492,0 5.2774,-0.793 6.9727,-2.3828 1.6875,-1.582 2.539,-4.3867 2.539,-8.4102 V 30.2695 h 9.7461 v 33.5352 c 0,4.5898 -0.7148,8.2734 -2.1445,11.0469 -1.4336,2.7734 -3.3906,4.7734 -5.8789,6.0351",
					style: {
						fill: "#ffffff",
						fillOpacity: 1,
						fillRule: "nonzero",
						stroke: "none"
					},
					id: "path18"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m 125.852,80.8867 c -2.485,1.25 -5.348,1.875 -8.579,1.875 -3.078,0 -5.953,-0.5664 -8.625,-1.6914 -2.675,-1.1211 -5.023,-2.7148 -7.043,-4.7734 h -0.515 l -0.699,5.6523 H 92.2773 V 30.2695 h 9.7457 v 37.7149 c 1.09,1.457 2.348,2.6289 3.778,3.5156 1.429,0.8906 2.902,1.5352 4.406,1.9453 1.508,0.4102 2.981,0.625 4.41,0.625 2.949,0 5.278,-0.793 6.973,-2.3828 1.687,-1.582 2.539,-4.3867 2.539,-8.4102 V 30.2695 h 9.746 v 33.5352 c 0,4.5898 -0.715,8.2734 -2.145,11.0469 -1.429,2.7734 -3.39,4.7734 -5.878,6.0351",
					style: {
						fill: "#ffffff",
						fillOpacity: 1,
						fillRule: "nonzero",
						stroke: "none"
					},
					id: "path20"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m 177.711,44.7344 c -1.027,-2.7344 -2.488,-4.6875 -4.383,-5.8399 -1.894,-1.164 -4.168,-1.7382 -6.812,-1.7382 -2.606,0 -4.864,0.5742 -6.758,1.7382 -1.899,1.1524 -3.36,3.1133 -4.383,5.8868 -1.027,2.7734 -1.539,6.5625 -1.539,11.3789 0,4.7148 0.504,8.457 1.516,11.2109 1.007,2.7539 2.468,4.6953 4.378,5.8398 1.918,1.1407 4.18,1.7071 6.786,1.7071 2.617,0 4.867,-0.5742 6.761,-1.7266 1.903,-1.1641 3.368,-3.125 4.414,-5.8984 1.039,-2.7657 1.555,-6.5625 1.555,-11.3672 0,-4.7266 -0.512,-8.4492 -1.535,-11.1914 z m 0.84,35.1953 c -3.36,1.8828 -7.367,2.832 -12.035,2.832 -4.629,0 -8.625,-0.957 -11.981,-2.8828 -3.355,-1.9141 -5.961,-4.832 -7.812,-8.7578 -1.852,-3.9258 -2.774,-8.9453 -2.774,-15.0586 0,-6.1445 0.934,-11.1836 2.797,-15.1289 1.867,-3.9453 4.484,-6.8633 7.856,-8.7578 3.375,-1.9063 7.347,-2.8516 11.914,-2.8516 4.574,0 8.55,0.9571 11.941,2.8711 3.391,1.9141 5.996,4.8438 7.836,8.7891 1.832,3.9453 2.75,8.9648 2.75,15.0781 0,6.1406 -0.91,11.1914 -2.727,15.125 -1.82,3.9453 -4.41,6.8555 -7.765,8.7422",
					style: {
						fill: "#ffffff",
						fillOpacity: 1,
						fillRule: "nonzero",
						stroke: "none"
					},
					id: "path22"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m 218.766,39.1367 -14.989,42.8125 h -10.265 l 18.801,-51.6797 h 12.308 l 18.793,51.6797 h -9.703 L 218.766,39.1367",
					style: {
						fill: "#ffffff",
						fillOpacity: 1,
						fillRule: "nonzero",
						stroke: "none"
					},
					id: "path24"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m 272.168,37.918 c -1.973,-0.8203 -3.957,-1.2305 -5.941,-1.2305 -2.895,0 -5.075,0.6836 -6.536,2.0586 -1.461,1.3789 -2.195,3.3516 -2.195,5.918 0,2.5 0.813,4.4726 2.43,5.9101 1.617,1.4453 4.246,2.3321 7.887,2.6836 l 9.738,0.9766 V 42.0469 c -1.613,-1.9336 -3.41,-3.3086 -5.383,-4.1289 z m 5.785,43.0078 c -3.07,1.2187 -6.906,1.8359 -11.539,1.8359 -2.398,0 -4.965,-0.1953 -7.699,-0.5781 -2.735,-0.3789 -5.242,-0.9453 -7.508,-1.707 v -7.7852 c 2.395,0.793 4.789,1.3594 7.203,1.7109 2.41,0.3399 4.578,0.5157 6.504,0.5157 2.899,0 5.27,-0.3321 7.137,-0.9961 1.867,-0.6641 3.254,-1.8164 4.152,-3.4453 0.899,-1.6328 1.348,-3.8868 1.348,-6.7696 v -3.2617 l -10.582,-1.1015 c -6.715,-0.6055 -11.602,-2.2071 -14.645,-4.7969 -3.047,-2.5977 -4.57,-6.1914 -4.57,-10.7891 0,-4.3945 1.391,-7.8906 4.176,-10.4687 2.781,-2.5782 6.613,-3.8789 11.496,-3.8789 2.949,0 5.676,0.5468 8.156,1.6211 2.492,1.0742 4.543,2.6757 6.156,4.7968 h 0.567 l 0.691,-5.5586 h 8.07 v 32.8711 c 0,4.9414 -0.75,8.8399 -2.253,11.6797 -1.516,2.8516 -3.801,4.8945 -6.86,6.1055",
					style: {
						fill: "#ffffff",
						fillOpacity: 1,
						fillRule: "nonzero",
						stroke: "none"
					},
					id: "path26"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m 322.418,37.7305 c -3.332,0 -5.797,0.8125 -7.398,2.4414 -1.602,1.6328 -2.403,4.4922 -2.403,8.5742 v 25.1758 h 15.113 v 8.0273 h -15.113 v 18.6248 h -8.058 l -1.684,-18.6248 h -9.145 v -8.0273 h 9.145 V 47.1367 c 0,-6.1836 1.496,-10.6836 4.496,-13.5156 3,-2.832 7.238,-4.25 12.711,-4.25 1.398,0 2.805,0.0898 4.219,0.2539 1.418,0.1758 2.758,0.4102 4.035,0.6953 v 8.125 c -1.152,-0.2265 -2.195,-0.4023 -3.145,-0.5273 -0.949,-0.1289 -1.875,-0.1875 -2.773,-0.1875",
					style: {
						fill: "#ffffff",
						fillOpacity: 1,
						fillRule: "nonzero",
						stroke: "none"
					},
					id: "path28"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m 335.938,30.2695 h 9.742 v 51.6797 h -9.742 V 30.2695",
					style: {
						fill: "#ffffff",
						fillOpacity: 1,
						fillRule: "nonzero",
						stroke: "none"
					},
					id: "path30"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m 340.836,103.512 c -2.121,0 -3.715,-0.508 -4.809,-1.512 -1.086,-1.016 -1.632,-2.4414 -1.632,-4.2773 0,-1.7774 0.546,-3.1641 1.632,-4.1797 1.094,-1.0157 2.688,-1.5235 4.809,-1.5235 2.109,0 3.711,0.5078 4.805,1.5235 1.086,1.0156 1.632,2.4023 1.632,4.1797 0,1.8359 -0.546,3.2613 -1.632,4.2773 -1.094,1.004 -2.696,1.512 -4.805,1.512",
					style: {
						fill: "#ffffff",
						fillOpacity: 1,
						fillRule: "nonzero",
						stroke: "none"
					},
					id: "path32"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m 377.977,39.1445 -14.993,42.8047 h -10.261 l 18.8,-51.6797 h 12.309 l 18.789,51.6797 h -9.703 L 377.977,39.1445",
					style: {
						fill: "#ffffff",
						fillOpacity: 1,
						fillRule: "nonzero",
						stroke: "none"
					},
					id: "path34"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m 418.293,68.6992 c 0.937,2.5977 2.266,4.4531 3.984,5.5742 1.731,1.1329 3.793,1.6914 6.188,1.6914 2.422,0 4.465,-0.5664 6.125,-1.7109 1.672,-1.1406 2.93,-2.9961 3.801,-5.5742 0.793,-2.3594 1.179,-5.5508 1.25,-9.3867 h -22.684 c 0.074,3.8359 0.488,7.039 1.336,9.4062 z m 21.34,11.1133 c -3.031,1.9609 -6.715,2.9492 -11.031,2.9492 -4.477,0 -8.317,-0.9765 -11.52,-2.9219 -3.207,-1.9531 -5.668,-4.9101 -7.387,-8.8867 -1.73,-3.9726 -2.59,-8.9258 -2.59,-14.8437 0,-6.2696 0.93,-11.375 2.793,-15.3203 1.868,-3.9375 4.672,-6.836 8.422,-8.6914 3.743,-1.8477 8.414,-2.7735 14.012,-2.7735 2.238,0 4.492,0.1563 6.762,0.4688 2.265,0.3203 4.66,0.8281 7.179,1.5234 v 7.793 c -2.265,-0.6055 -4.464,-1.086 -6.574,-1.4258 -2.109,-0.3516 -4.152,-0.5273 -6.105,-0.5273 -3.891,0 -7.067,0.5546 -9.535,1.6679 -2.473,1.1055 -4.289,2.9297 -5.434,5.4805 -1,2.2109 -1.484,5.207 -1.617,8.7187 h 31.875 v 2.8516 c 0,6.0469 -0.781,11.0547 -2.356,15.0313 -1.562,3.9726 -3.867,6.9414 -6.894,8.9062",
					style: {
						fill: "#ffffff",
						fillOpacity: 1,
						fillRule: "nonzero",
						stroke: "none"
					},
					id: "path36"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m 513.289,101.473 c -7.035,0 -13.043,-1.282 -18.027,-3.848 -4.992,-2.5703 -8.813,-6.5039 -11.449,-11.8281 -2.649,-5.3203 -3.969,-12.1563 -3.969,-20.5156 0,-6.4961 0.754,-12.0235 2.238,-16.5821 1.496,-4.5625 3.676,-8.2539 6.535,-11.0937 2.856,-2.8321 6.293,-4.9141 10.301,-6.2422 4.016,-1.3281 8.547,-1.9922 13.617,-1.9922 2.863,0 5.617,0.2266 8.258,0.6836 2.637,0.4609 5.078,1.0547 7.316,1.7891 v 8.5937 c -2.578,-0.8906 -5.058,-1.5352 -7.433,-1.9258 -2.375,-0.3984 -4.828,-0.5937 -7.348,-0.5937 -4.906,0 -9.086,0.8593 -12.547,2.5664 -3.445,1.7109 -6.074,4.582 -7.875,8.625 -1.804,4.0312 -2.703,9.4922 -2.703,16.3554 0,6.6797 0.899,12.0313 2.703,16.0547 1.801,4.0235 4.457,6.9336 7.973,8.7227 3.508,1.7851 7.836,2.6836 12.969,2.6836 2.48,0 4.914,-0.1641 7.265,-0.4766 2.367,-0.3125 4.7,-0.8125 6.996,-1.4765 v 8.5546 c -2.324,0.6367 -4.726,1.1137 -7.199,1.4457 -2.472,0.332 -5.012,0.5 -7.621,0.5",
					style: {
						fill: "#ffffff",
						fillOpacity: 1,
						fillRule: "nonzero",
						stroke: "none"
					},
					id: "path38"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m 536.738,30.2695 h 9.75 v 76.7575 h -9.75 V 30.2695",
					style: {
						fill: "#ffffff",
						fillOpacity: 1,
						fillRule: "nonzero",
						stroke: "none"
					},
					id: "path40"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m 568.266,68.6992 c 0.929,2.5977 2.257,4.4531 3.988,5.5742 1.719,1.1329 3.777,1.6914 6.172,1.6914 2.426,0 4.476,-0.5664 6.137,-1.7109 1.66,-1.1406 2.929,-2.9961 3.8,-5.5742 0.793,-2.3594 1.18,-5.5508 1.25,-9.3867 H 566.93 c 0.074,3.8359 0.48,7.039 1.336,9.4062 z m 21.328,11.1133 c -3.028,1.9609 -6.703,2.9492 -11.02,2.9492 -4.484,0 -8.324,-0.9765 -11.519,-2.9219 -3.203,-1.9531 -5.668,-4.9101 -7.399,-8.8867 -1.718,-3.9726 -2.586,-8.9258 -2.586,-14.8437 0,-6.2696 0.938,-11.375 2.801,-15.3203 1.867,-3.9375 4.672,-6.836 8.414,-8.6914 3.75,-1.8477 8.422,-2.7735 14.012,-2.7735 2.246,0 4.492,0.1563 6.769,0.4688 2.27,0.3203 4.661,0.8281 7.184,1.5234 v 7.793 c -2.277,-0.6055 -4.469,-1.086 -6.578,-1.4258 -2.121,-0.3516 -4.152,-0.5273 -6.117,-0.5273 -3.875,0 -7.063,0.5546 -9.535,1.6679 -2.469,1.1055 -4.278,2.9297 -5.43,5.4805 -1,2.2109 -1.477,5.207 -1.61,8.7187 h 31.875 v 2.8516 c 0,6.0469 -0.789,11.0547 -2.351,15.0313 -1.574,3.9726 -3.871,6.9414 -6.91,8.9062",
					style: {
						fill: "#ffffff",
						fillOpacity: 1,
						fillRule: "nonzero",
						stroke: "none"
					},
					id: "path42"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m 630.492,37.918 c -1.972,-0.8203 -3.957,-1.2305 -5.937,-1.2305 -2.895,0 -5.075,0.6836 -6.539,2.0586 -1.457,1.3789 -2.188,3.3516 -2.188,5.918 0,2.5 0.813,4.4726 2.422,5.9101 1.621,1.4453 4.25,2.3321 7.887,2.6836 l 9.738,0.9766 V 42.0469 c -1.609,-1.9336 -3.41,-3.3086 -5.383,-4.1289 z m 5.785,43.0078 c -3.066,1.2187 -6.91,1.8359 -11.539,1.8359 -2.394,0 -4.965,-0.1953 -7.699,-0.5781 -2.734,-0.3789 -5.238,-0.9453 -7.504,-1.707 v -7.7852 c 2.395,0.793 4.789,1.3594 7.199,1.7109 2.414,0.3399 4.586,0.5157 6.508,0.5157 2.895,0 5.266,-0.3321 7.133,-0.9961 1.867,-0.6641 3.254,-1.8164 4.152,-3.4453 0.899,-1.6328 1.348,-3.8868 1.348,-6.7696 v -3.2617 l -10.578,-1.1015 c -6.715,-0.6055 -11.598,-2.2071 -14.649,-4.7969 -3.046,-2.5977 -4.57,-6.1914 -4.57,-10.7891 0,-4.3945 1.395,-7.8906 4.18,-10.4687 2.773,-2.5782 6.617,-3.8789 11.488,-3.8789 2.953,0 5.68,0.5468 8.16,1.6211 2.492,1.0742 4.543,2.6757 6.157,4.7968 h 0.566 l 0.691,-5.5586 h 8.071 v 32.8711 c 0,4.9414 -0.75,8.8399 -2.254,11.6797 -1.516,2.8516 -3.801,4.8945 -6.86,6.1055",
					style: {
						fill: "#ffffff",
						fillOpacity: 1,
						fillRule: "nonzero",
						stroke: "none"
					},
					id: "path44"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m 691.605,80.8867 c -2.48,1.25 -5.343,1.875 -8.578,1.875 -3.078,0 -5.949,-0.5664 -8.629,-1.6914 -2.675,-1.1211 -5.019,-2.7148 -7.043,-4.7734 h -0.507 l -0.703,5.6523 h -8.11 V 30.2695 h 9.742 v 37.7149 c 1.094,1.457 2.356,2.6289 3.782,3.5156 1.425,0.8906 2.902,1.5352 4.406,1.9453 1.504,0.4102 2.98,0.625 4.406,0.625 2.949,0 5.274,-0.793 6.977,-2.3828 1.687,-1.582 2.539,-4.3867 2.539,-8.4102 V 30.2695 h 9.742 v 33.5352 c 0,4.5898 -0.715,8.2734 -2.141,11.0469 -1.437,2.7734 -3.39,4.7734 -5.883,6.0351",
					style: {
						fill: "#ffffff",
						fillOpacity: 1,
						fillRule: "nonzero",
						stroke: "none"
					},
					id: "path46"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m 717.164,103.512 c -2.117,0 -3.711,-0.508 -4.805,-1.512 -1.086,-1.016 -1.632,-2.4414 -1.632,-4.2773 0,-1.7774 0.546,-3.1641 1.632,-4.1797 1.094,-1.0157 2.688,-1.5235 4.805,-1.5235 2.109,0 3.715,0.5078 4.809,1.5235 1.082,1.0156 1.629,2.4023 1.629,4.1797 0,1.8359 -0.547,3.2613 -1.629,4.2773 -1.094,1.004 -2.7,1.512 -4.809,1.512",
					style: {
						fill: "#ffffff",
						fillOpacity: 1,
						fillRule: "nonzero",
						stroke: "none"
					},
					id: "path48"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m 712.27,30.2695 h 9.742 V 81.9492 H 712.27 V 30.2695",
					style: {
						fill: "#ffffff",
						fillOpacity: 1,
						fillRule: "nonzero",
						stroke: "none"
					},
					id: "path50"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m 768.742,80.8867 c -2.492,1.25 -5.355,1.875 -8.578,1.875 -3.078,0 -5.961,-0.5664 -8.629,-1.6914 -2.676,-1.1211 -5.019,-2.7148 -7.043,-4.7734 h -0.519 l -0.692,5.6523 H 735.16 V 30.2695 h 9.75 v 37.7149 c 1.086,1.457 2.348,2.6289 3.774,3.5156 1.437,0.8906 2.902,1.5352 4.406,1.9453 1.515,0.4102 2.98,0.625 4.418,0.625 2.949,0 5.273,-0.793 6.965,-2.3828 1.691,-1.582 2.539,-4.3867 2.539,-8.4102 V 30.2695 h 9.754 v 33.5352 c 0,4.5898 -0.715,8.2734 -2.153,11.0469 -1.425,2.7734 -3.39,4.7734 -5.871,6.0351",
					style: {
						fill: "#ffffff",
						fillOpacity: 1,
						fillRule: "nonzero",
						stroke: "none"
					},
					id: "path52"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m 820.641,43.0938 c -1.368,-1.7383 -3.047,-3.0274 -5.032,-3.8672 -1.992,-0.8399 -3.996,-1.2618 -6.015,-1.2618 -2.524,0 -4.742,0.5274 -6.676,1.5938 -1.926,1.0625 -3.438,2.8984 -4.543,5.5078 -1.105,2.6172 -1.652,6.25 -1.652,10.8984 0,6.7461 1.371,11.6016 4.105,14.5586 2.735,2.961 6.692,4.4454 11.891,4.4454 1.484,0 2.922,-0.0977 4.289,-0.2852 1.367,-0.1953 2.578,-0.4297 3.633,-0.7109 z m -1.328,39.3554 c -1.973,0.2031 -3.907,0.3125 -5.801,0.3125 -8.805,0 -15.449,-2.3359 -19.946,-6.9844 -4.48,-4.6562 -6.73,-11.5625 -6.73,-20.7109 0,-6.0859 0.891,-10.9766 2.68,-14.6797 1.785,-3.6992 4.172,-6.414 7.16,-8.125 2.98,-1.707 6.203,-2.5586 9.652,-2.5586 3.051,0 5.727,0.5586 8.039,1.6797 2.317,1.125 4.223,2.5781 5.719,4.3477 h 0.555 v -4.5117 c 0,-5.4415 -1.25,-9.2891 -3.75,-11.543 -2.5,-2.2461 -6.43,-3.3711 -11.774,-3.3711 -2.238,0 -4.613,0.1953 -7.113,0.5976 -2.5,0.3907 -5.109,1.004 -7.816,1.8243 v -8.0743 c 2.433,-0.72261 5.023,-1.28121 7.789,-1.66011 2.773,-0.38281 5.351,-0.56641 7.746,-0.56641 8.265,0 14.441,1.89452 18.515,5.69142 4.075,3.8008 6.106,10.0586 6.106,18.7695 v 47.3555 c -1.621,0.5351 -3.371,0.9844 -5.246,1.3555 -1.887,0.3632 -3.813,0.6445 -5.785,0.8515",
					style: {
						fill: "#ffffff",
						fillOpacity: 1,
						fillRule: "nonzero",
						stroke: "none"
					},
					id: "path54"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m 900.34,64.3711 c -3.051,-2.6563 -7.926,-3.9844 -14.649,-3.9844 -1.582,0 -3.046,0.0391 -4.406,0.1172 -1.347,0.0781 -2.707,0.2149 -4.074,0.4024 v 31.7773 c 1.484,0.2812 3,0.4961 4.523,0.625 1.516,0.1172 3.188,0.1836 4.985,0.1836 6.152,0 10.726,-1.3164 13.719,-3.9649 2.98,-2.6445 4.472,-6.8828 4.472,-12.7031 0,-5.6367 -1.523,-9.7851 -4.57,-12.4531 z m -14.363,36.9649 c -3.391,0 -6.606,-0.168 -9.653,-0.481 -3.051,-0.32 -6.07,-0.781 -9.051,-1.3745 v -69.211 h 9.938 v 22.6094 c 1.457,-0.1289 2.836,-0.2148 4.125,-0.2851 1.289,-0.0586 2.676,-0.0977 4.172,-0.0977 9.887,0 17.215,2.0898 21.992,6.2695 4.766,4.1797 7.152,10.2344 7.152,18.1446 0,8.457 -2.406,14.6406 -7.23,18.5546 -4.817,3.9063 -11.969,5.8712 -21.445,5.8712",
					style: {
						fill: "#ffffff",
						fillOpacity: 1,
						fillRule: "nonzero",
						stroke: "none"
					},
					id: "path56"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m 948.934,82.5156 c -2.801,0 -5.469,-0.6133 -8.02,-1.8437 -2.551,-1.2422 -4.672,-3.086 -6.34,-5.5586 h -0.566 l -0.742,6.8359 h -8.071 V 30.2695 h 9.75 V 66.793 c 1.055,1.4648 2.325,2.6758 3.821,3.664 1.492,0.9766 3.086,1.7188 4.777,2.2071 1.699,0.4882 3.34,0.7422 4.922,0.7422 0.773,0 1.547,-0.0313 2.308,-0.0782 0.762,-0.0508 1.512,-0.1367 2.266,-0.2656 v 9.0742 c -0.598,0.125 -1.223,0.2227 -1.894,0.293 -0.665,0.0586 -1.411,0.0859 -2.211,0.0859",
					style: {
						fill: "#ffffff",
						fillOpacity: 1,
						fillRule: "nonzero",
						stroke: "none"
					},
					id: "path58"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M 991.367,44.7344 C 990.344,42 988.875,40.0469 986.98,38.8945 c -1.894,-1.164 -4.16,-1.7382 -6.808,-1.7382 -2.609,0 -4.867,0.5742 -6.762,1.7382 -1.894,1.1524 -3.351,3.1133 -4.379,5.8868 -1.023,2.7734 -1.543,6.5625 -1.543,11.3789 0,4.7148 0.508,8.457 1.516,11.2109 1.016,2.7539 2.473,4.6953 4.387,5.8398 1.914,1.1407 4.172,1.7071 6.781,1.7071 2.617,0 4.863,-0.5742 6.762,-1.7266 1.902,-1.1641 3.371,-3.125 4.414,-5.8984 1.035,-2.7657 1.554,-6.5625 1.554,-11.3672 0,-4.7266 -0.507,-8.4492 -1.535,-11.1914 z m 0.84,35.1953 c -3.359,1.8828 -7.367,2.832 -12.035,2.832 -4.633,0 -8.629,-0.957 -11.981,-2.8828 -3.359,-1.9141 -5.957,-4.832 -7.816,-8.7578 -1.844,-3.9258 -2.773,-8.9453 -2.773,-15.0586 0,-6.1445 0.937,-11.1836 2.804,-15.1289 1.867,-3.9453 4.485,-6.8633 7.856,-8.7578 3.371,-1.9063 7.347,-2.8516 11.91,-2.8516 4.57,0 8.547,0.9571 11.937,2.8711 3.391,1.9141 6,4.8438 7.836,8.7891 1.835,3.9453 2.755,8.9648 2.755,15.0781 0,6.1406 -0.91,11.1914 -2.723,15.125 -1.829,3.9453 -4.418,6.8555 -7.77,8.7422",
					style: {
						fill: "#ffffff",
						fillOpacity: 1,
						fillRule: "nonzero",
						stroke: "none"
					},
					id: "path60"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m 1044.53,43.1914 c -1.37,-1.9062 -3.03,-3.293 -4.99,-4.1797 -1.96,-0.8906 -3.98,-1.3281 -6.06,-1.3281 -2.55,0 -4.79,0.5469 -6.71,1.6406 -1.94,1.0821 -3.44,2.9492 -4.53,5.5742 -1.09,2.6289 -1.63,6.2891 -1.63,10.9766 0,6.7773 1.37,11.6406 4.12,14.6016 2.76,2.9687 6.8,4.4414 12.15,4.4414 1.34,0 2.68,-0.0782 4.03,-0.2344 1.36,-0.1563 2.56,-0.3516 3.62,-0.5742 z m 0,38.9922 c -1.12,0.168 -2.33,0.293 -3.62,0.4102 -1.29,0.1093 -2.6,0.1679 -3.93,0.1679 -5.73,0 -10.53,-1.0351 -14.42,-3.0859 -3.88,-2.0625 -6.83,-5.1485 -8.83,-9.2695 -2.01,-4.1094 -3.01,-9.2266 -3.01,-15.3399 0,-6.1719 0.91,-11.1445 2.73,-14.8945 1.82,-3.75 4.26,-6.4922 7.32,-8.211 3.06,-1.7304 6.47,-2.5898 10.24,-2.5898 3.01,0 5.69,0.5977 8.04,1.7969 2.35,1.2109 4.27,2.7656 5.76,4.6601 h 0.56 l 0.6,-5.5586 h 8.26 v 76.7575 h -9.7 V 82.1836",
					style: {
						fill: "#ffffff",
						fillOpacity: 1,
						fillRule: "nonzero",
						stroke: "none"
					},
					id: "path62"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m 1098.29,44.1875 c -1.05,-1.457 -2.28,-2.6289 -3.68,-3.5156 -1.4,-0.8906 -2.85,-1.5352 -4.36,-1.9453 -1.5,-0.4102 -2.96,-0.6133 -4.36,-0.6133 -2.73,0 -4.97,0.7695 -6.69,2.3242 -1.73,1.5508 -2.59,4.3359 -2.59,8.3594 v 33.1523 h -9.75 V 48.2695 c 0,-4.5898 0.72,-8.2734 2.15,-11.0351 1.43,-2.7735 3.39,-4.7774 5.9,-6.0156 2.5,-1.2305 5.37,-1.8477 8.6,-1.8477 2.86,0 5.59,0.5391 8.19,1.6133 2.6,1.0742 4.93,2.6758 7.01,4.7929 h 0.52 l 0.7,-5.5078 h 8.07 v 51.6797 h -9.71 V 44.1875",
					style: {
						fill: "#ffffff",
						fillOpacity: 1,
						fillRule: "nonzero",
						stroke: "none"
					},
					id: "path64"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m 1144.04,82.7617 c -5.44,0 -10.05,-0.9375 -13.83,-2.8047 -3.78,-1.875 -6.66,-4.7734 -8.64,-8.7187 -2,-3.9453 -2.99,-9.0039 -2.99,-15.1758 0,-6.1445 0.92,-11.1836 2.77,-15.1289 1.86,-3.9453 4.52,-6.8633 8.02,-8.7578 3.5,-1.9063 7.8,-2.8516 12.9,-2.8516 2.14,0 4.27,0.1758 6.36,0.5469 2.1,0.3594 4.13,0.8789 6.09,1.543 v 8.164 c -2.17,-0.6953 -4.15,-1.2109 -5.92,-1.5429 -1.77,-0.3321 -3.48,-0.5 -5.13,-0.5 -3.27,0 -6.02,0.6171 -8.26,1.8281 -2.24,1.2187 -3.92,3.2031 -5.06,5.9375 -1.13,2.7422 -1.7,6.375 -1.7,10.9062 0,4.4336 0.6,7.9883 1.8,10.6836 1.19,2.6953 3.02,4.6407 5.48,5.8399 2.45,1.2109 5.55,1.8086 9.28,1.8086 1.55,0 3.12,-0.0899 4.71,-0.2852 1.58,-0.1836 3.18,-0.5078 4.8,-0.9453 v 8.125 c -1.64,0.4375 -3.38,0.7695 -5.2,0.9961 -1.82,0.2148 -3.65,0.332 -5.48,0.332",
					style: {
						fill: "#ffffff",
						fillOpacity: 1,
						fillRule: "nonzero",
						stroke: "none"
					},
					id: "path66"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m 1185.92,37.7305 c -3.33,0 -5.79,0.8125 -7.39,2.4414 -1.61,1.6328 -2.41,4.4922 -2.41,8.5742 v 25.1758 h 15.12 v 8.0273 h -15.12 v 18.6248 h -8.06 l -1.68,-18.6248 h -9.14 v -8.0273 h 9.14 V 47.1367 c 0,-6.1836 1.5,-10.6836 4.5,-13.5156 3,-2.832 7.24,-4.25 12.71,-4.25 1.4,0 2.8,0.0898 4.22,0.2539 1.42,0.1758 2.75,0.4102 4.03,0.6953 v 8.125 c -1.15,-0.2265 -2.19,-0.4023 -3.14,-0.5273 -0.95,-0.1289 -1.88,-0.1875 -2.78,-0.1875",
					style: {
						fill: "#ffffff",
						fillOpacity: 1,
						fillRule: "nonzero",
						stroke: "none"
					},
					id: "path68"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m 1229.87,54.4492 c -2.13,2.2461 -5.51,3.8477 -10.14,4.7969 l -7.28,1.4258 c -2.48,0.5664 -4.21,1.4336 -5.17,2.5859 -0.97,1.1524 -1.45,2.5899 -1.45,4.2969 0,1.3984 0.39,2.668 1.15,3.8281 0.76,1.1524 2.04,2.082 3.84,2.7735 1.81,0.7031 4.23,1.0468 7.28,1.0468 2.15,0 4.22,-0.1289 6.22,-0.4023 2,-0.2735 4.02,-0.6914 6.04,-1.2578 v 7.6445 c -1.84,0.5078 -3.8,0.8984 -5.9,1.1641 -2.09,0.2734 -4.28,0.4101 -6.55,0.4101 -7.21,0 -12.56,-1.4453 -16.06,-4.3281 -3.5,-2.8789 -5.25,-6.582 -5.25,-11.1133 0,-3.8281 1.03,-6.9219 3.08,-9.2851 2.05,-2.3633 5.4,-4.043 10.07,-5.0586 l 7.27,-1.3789 c 2.49,-0.5664 4.25,-1.3868 5.28,-2.4493 1.02,-1.0546 1.53,-2.5976 1.53,-4.6289 0,-2.375 -0.89,-4.2382 -2.68,-5.6054 -1.78,-1.3594 -4.71,-2.043 -8.79,-2.043 -2.46,0 -4.89,0.1875 -7.3,0.5469 -2.41,0.3633 -4.87,0.9375 -7.39,1.7383 v -7.6954 c 2.27,-0.7031 4.63,-1.2304 7.09,-1.5898 2.45,-0.3711 5,-0.5469 7.65,-0.5469 6.68,0 11.79,1.3946 15.34,4.1992 3.55,2.8008 5.31,6.5899 5.31,11.375 0,4.1211 -1.06,7.2969 -3.19,9.5508",
					style: {
						fill: "#ffffff",
						fillOpacity: 1,
						fillRule: "nonzero",
						stroke: "none"
					},
					id: "path70"
				})
			]
		})
	})]
});
export default SvgHygan;
